const BASE = 'https://et-pos.store/quickbooks';

function getToken() {
    return localStorage.getItem('etpos_token') || '';
}

function headers(isJson = true) {
    const h = {
        'Accept': 'application/json',
        'Authorization': `Bearer ${getToken()}`,
        'X-Requested-With': 'XMLHttpRequest',
    };
    if (isJson) h['Content-Type'] = 'application/json';
    return h;
}

async function request(method, path, body) {
    const opts = { method, headers: headers() };
    if (body) opts.body = JSON.stringify(body);
    const res = await fetch(`${BASE}${path}`, opts);
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.message || `Request failed: ${res.status}`);
    return data;
}

export const quickbooksApi = {
    getAuthorizationUrl:  ()       => request('GET',  '/auth-url'),
    handleCallback:       (params) => request('GET',  `/callback?${new URLSearchParams(params)}`),
    testConnection:       ()       => request('GET',  '/test-connection'),
    disconnect:           ()       => request('POST', '/disconnect'),
    updateSettings:       (body)   => request('POST', '/update-settings', body),
    getAccounts:          ()       => request('GET',  '/accounts'),
    getCustomers:         ()       => request('GET',  '/customers'),
    getVendors:           ()       => request('GET',  '/vendors'),
    getInvoices:          ()       => request('GET',  '/invoices'),
    getItems:             ()       => request('GET',  '/items'),
    getApiLogs:           ()       => request('GET',  '/api-logs'),
    syncAllCustomers:     ()       => request('POST', '/sync-customers'),
    syncAllProducts:      ()       => request('POST', '/sync-products'),
    syncAllInvoices:      ()       => request('POST', '/sync-invoices'),
};
